var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUpvote(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "inherit",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.66634 19.1654H6.66634C6.31272 19.1654 5.97358 19.0249 5.72353 18.7748C5.47348 18.5248 5.33301 18.1857 5.33301 17.832V13.1654C5.33301 12.8117 5.47348 12.4726 5.72353 12.2226C5.97358 11.9725 6.31272 11.832 6.66634 11.832H8.66634M13.333 10.4987V7.83203C13.333 7.3016 13.1223 6.79289 12.7472 6.41782C12.3721 6.04275 11.8634 5.83203 11.333 5.83203L8.66634 11.832V19.1654H16.1863C16.5079 19.169 16.8199 19.0563 17.0649 18.848C17.31 18.6398 17.4715 18.35 17.5197 18.032L18.4397 12.032C18.4687 11.8409 18.4558 11.6458 18.4019 11.4602C18.348 11.2746 18.2544 11.1029 18.1276 10.957C18.0008 10.8112 17.8437 10.6947 17.6674 10.6155C17.4911 10.5364 17.2996 10.4965 17.1063 10.4987H13.333Z",
    stroke: "inherit",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpvote);
export default __webpack_public_path__ + "static/media/upvote.1d439b6a23d198931e32a41f8b8dd669.svg";
export { ForwardRef as ReactComponent };